"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEventQueue_1 = require("./getEventQueue");
var resetEventQueue = function () {
    var queue = (0, getEventQueue_1.default)();
    queue.length = 0;
};
exports.default = resetEventQueue;
